import { render, staticRenderFns } from "./ShareableGroupEmailForm.vue?vue&type=template&id=936d2ff0&scoped=true&"
import script from "./ShareableGroupEmailForm.vue?vue&type=script&lang=js&"
export * from "./ShareableGroupEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d2ff0",
  null
  
)

export default component.exports